'use client'

import React, { memo } from 'react'
import { TBaseComponentProps } from '@segway/core'

type TMethodItemWrapperProps = TBaseComponentProps & {
  placeOrderAvailable: boolean
  handleCheckBefore: () => void
}

/**
 * Method Item 支付列表组件
 *
 * @param {boolean} [placeOrderAvailable] - 支付是都可用
 * @param {function} [handleCheckBefore] - 支付前检查
 *
 */
const MethodItemWrapper = ({
  children,
  placeOrderAvailable,
  handleCheckBefore,
}: TMethodItemWrapperProps) => {
  return (
    <div className="relative rounded-[8px] border border-[#D1D1D4]">
      {!placeOrderAvailable && (
        // 遮罩层，阻止点击支付下单，必须先勾选协议和点击谷歌人机验证
        <div
          onClick={handleCheckBefore}
          className="absolute left-0 top-0 z-[10] h-full w-full rounded-[8px] bg-white opacity-30"
        />
      )}
      {children}
    </div>
  )
}

export default memo(MethodItemWrapper)
